module.exports = __webpack_public_path__ + "static/media/jayathi-murthy.6111a0dc.png";